import { CategoryMultiFilterSelect, type CategoryMultiFilterSelectProps } from "@/components/ui/category-multi-filter-select";
import { LabeledFilterField } from "@/components/ui/labeled-filter-field";

export type CategoryLabeledFilterSelectProps = CategoryMultiFilterSelectProps & {
  label?: string;
  labelBgClass?: string;
};

export function CategoryLabeledFilterSelect({
  label = "Categorias",
  labelBgClass,
  id,
  "aria-label": ariaLabel,
  ...props
}: CategoryLabeledFilterSelectProps) {
  const resolvedLabel = ariaLabel ?? label;
  return (
    <LabeledFilterField label={label} htmlFor={id} labelBgClass={labelBgClass}>
      <CategoryMultiFilterSelect id={id} aria-label={resolvedLabel} {...props} />
    </LabeledFilterField>
  );
}
